import { render, staticRenderFns } from "./OrdersByDeliveryDate.vue?vue&type=template&id=0fbc725e&scoped=true"
import script from "./OrdersByDeliveryDate.vue?vue&type=script&lang=js"
export * from "./OrdersByDeliveryDate.vue?vue&type=script&lang=js"
import style0 from "./OrdersByDeliveryDate.vue?vue&type=style&index=0&id=0fbc725e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbc725e",
  null
  
)

export default component.exports